import inputDisabled from '../../../../common/algorithms/input-disabled';

const secondary = (params) => inputDisabled(params);

export default secondary;
